import { Card } from 'primereact/card';
import { Rating, RatingChangeEvent } from 'primereact/rating';
import React, { useState } from 'react';
import { FormSectionElements } from 'src/entities/formTemplateDataType';
import { StarRatingProps } from './StarRatingComponent';
import { getRootComponent } from '../../utilities/ElementUtils';

const StartRatingAccessibilityComponent = ({field, title, isEng, callbackElement} : StarRatingProps) => {
    const [rating, setRating] = useState<number>(field.Value ?? 0);

    const tooltips = {
        en: [
            "Terrible",
            "Bad",
            "Average",
            "Great",
            "Awesome",
        ],
        fr: [
            "Terrible",
            "Mauvais",
            "Moyenne",
            "Super",
            "Génial",
        ],
    }

    const getRatingTip = () => {
        if (rating === 0) {
            return isEng? 'Your rating': 'Votre note';
        }
        return tooltips[isEng? 'en' : 'fr'][rating-1];
    }

    const handleRatingChange = (e: RatingChangeEvent) => {
        setRating(e.value);
        field.Value = e.value;
        const root = getRootComponent(field)
        callbackElement(root);
    }

    return (
        <div className="ontario-margin-top-24-! ontario-margin-bottom-32-!">
            {/* @ts-ignore */}
            <Card title={title || isEng ? 'Please rate the quiz' : 'Veuillez évaluer le quiz'}>
                <div style={{display: 'flex'}}>
                    <Rating 
                        value={rating}
                        onChange={handleRatingChange}
                        cancel={false}
                    />
                    <span className='rating-tip'>{getRatingTip()}</span>
                </div>
            </Card>
        </div>
    )
}

export default StartRatingAccessibilityComponent;